export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  response: (state) => state.response,
};
